<template>
  <svg viewBox="-5 0 24 24" fill="none" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 3C4 1.34315 5.34315 0 7 0C8.65685 0 10 1.34315 10 3V11C10 12.6569 8.65685 14 7 14C5.34315 14 4 12.6569 4 11V3Z"
      fill="white"
    />
    <path
      d="M8 17.9291C11.3923 17.4439 14 14.5265 14 11C14 10.4477 13.5523 10 13 10C12.4477 10 12 10.4477 12 11C12 13.7614 9.76142 16 7 16C4.23858 16 2 13.7614 2 11C2 10.4477 1.55228 10 1 10C0.447715 10 0 10.4477 0 11C0 14.5265 2.60771 17.4439 6 17.9291V20H3C2.44772 20 2 20.4477 2 21C2 21.5523 2.44772 22 3 22H11C11.5523 22 12 21.5523 12 21C12 20.4477 11.5523 20 11 20H8V17.9291Z"
      fill="white"
    />
  </svg>
</template>
